import { along, length, lineString, lineSliceAlong, nearestPointOnLine } from "@turf/turf";
import { field } from "geomag";
export function getFixMagVar(fix) {
    switch (fix?.type) {
        case "VOR":
        case "VORTAC":
        case "VORDME":
        case "DME":
        case "ILSDME":
        case "TACAN":
            return fix.declination;
        default:
            return null;
    }
}
export function getFixCoordinates(fix) {
    if (fix && "arp" in fix) {
        return fix.arp;
    }
    switch (fix?.type) {
        case "WPT":
        case "NDB":
        case "FRD":
            return fix.point;
        case "VOR":
        case "VORTAC":
        case "VORDME":
            return fix.vor;
        case "DME":
        case "ILSDME":
        case "TACAN":
            return [fix.dme[0], fix.dme[1]];
        default:
            return [0, 0];
    }
}
export function getRemainingRoute(ppos, legs) {
    if (legs.length < 2) {
        return {
            fixes: legs,
            projectedPos: ppos,
        };
    }
    let lineStr = lineString(legs.map((leg) => leg.location));
    const routeLengthNm = length(lineStr, { units: "nauticalmiles" });
    const nearestPoint = nearestPointOnLine(lineStr.geometry, ppos, {
        units: "nauticalmiles",
    });
    const posOnRoute = along(lineStr.geometry, Math.min(routeLengthNm, nearestPoint.properties.location ?? 0), {
        units: "nauticalmiles",
    });
    const routeLength = lineStr.geometry.coordinates.length;
    const remainingGeometry = lineSliceAlong(lineStr.geometry, Math.min(routeLengthNm, nearestPoint.properties.location ?? 0), routeLengthNm, { units: "nauticalmiles" });
    const fixes = legs.slice(routeLength - remainingGeometry.geometry.coordinates.length + 1);
    return { fixes, projectedPos: posOnRoute.geometry.coordinates, nearestPoint };
}
export function getMagVar(lon, lat) {
    return field(lat, lon).declination;
}
//# sourceMappingURL=navdataApiTypes.js.map